import React from 'react'
import { Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { createStyles } from 'antd-style'

const { Text } = Typography

interface AppLoaderProps {
  message?: string
}

const useStyles = createStyles(({ css }) => ({
  loading: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: var(--tt-bg, #f2f0eb);
    color: var(--tt-ink, #1a1816);
  `,
}))

export const AppLoader: React.FC<AppLoaderProps> = ({
  message = '论文台加载中...',
}) => {
  const { styles } = useStyles()
  return (
    <div className={styles.loading}>
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 48, color: 'var(--tt-accent, #2f4a6a)' }}
            spin
          />
        }
        size="large"
      />
      <div style={{ marginTop: 24, textAlign: 'center' }}>
        <Text style={{ fontSize: 16, color: 'var(--tt-ink, #1a1816)' }}>{message}</Text>
        <br />
        <Text style={{ fontSize: 12, color: 'var(--tt-muted, #5c5854)', marginTop: 8 }}>
          正在准备工作区...
        </Text>
      </div>
    </div>
  )
}
